import { useEffect } from "react";
import { motion } from "framer-motion";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — Incolour Films` : "Incolour Films — Toronto Film Production Company";
  }, [title]);
}

export function LineReveal({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "span" }) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeUp({ children, className = "", delay = 0, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`flex items-center gap-2 text-xs font-mono uppercase tracking-[0.22em] text-muted-foreground ${className}`}>
      <span className="inline-block h-2 w-2 bg-orange" aria-hidden="true" />
      {children}
    </p>
  );
}
